import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f061e2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "userDashboard" }
const _hoisted_2 = { class: "flex justify-content-between align-items-end pb-2" }
const _hoisted_3 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_4 = {
  key: 1,
  class: "mt-2 mb-0"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_loyalty-point" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "grayWide" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_SidebarUserWrapper = _resolveComponent("SidebarUserWrapper")!

  return (_openBlock(), _createBlock(_component_SidebarUserWrapper, {
    title: _ctx.$t('user.my_points'),
    sidebarComponent: _ctx.sidebarComponent
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            (_ctx.user.loyalty)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.$t("my_points.tier")) + ": ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.loyaltyTier ?? _ctx.$t("my_points.no_tier")), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.user.loyalty)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                  _createTextVNode(_toDisplayString(_ctx.$t("my_super_city.points")) + ": ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.loyaltyPoints) + " ", 1),
                  _hoisted_5
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.$route.name === 'MyPointsOverview' && _ctx.pointsTransferEnabled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "transferButton",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'MyPointsTransfer' })))
              }, _toDisplayString(_ctx.$t("my_points.transfer.action")), 1))
            : _createCommentVNode("", true)
        ]),
        _hoisted_6,
        _createVNode(_component_router_view, {
          loyaltyPoints: _ctx.loyaltyPoints,
          onRefresh: _ctx.loadUserLoyaltyInfo
        }, null, 8, ["loyaltyPoints", "onRefresh"])
      ])
    ]),
    _: 1
  }, 8, ["title", "sidebarComponent"]))
}